// extracted by mini-css-extract-plugin
module.exports = {"fetchedLink":"AttachmentsBlock__fetchedLink__CTkwo","image":"AttachmentsBlock__image__c81x+","commentMode":"AttachmentsBlock__commentMode__bNufh"};